export default {
  props: {
    name: String,
    options: Array,
    initSelected: [Array, Number, Object]
  },

  data () {
    return {
      multipleSelect: false,
      selected: null,
      hasInit: false
    }
  },

  mounted () {
    if (this.initSelected !== undefined && Array.isArray(this.initSelected)) {
      for (let s of this.initSelected) {
        this.selected.push(s.value)
      }
    }
  },

  methods: {
    emitChanges () {
      this.$emit('update', {
        name: this.name,
        value: this.selected
      })
    }
  },

  computed: {
    selectProps () {
      let basic = {
        required: false,
        selectLabel: this.$t('_select').toLowerCase(),
        selectedLabel: '',
        deselectLabel: this.$t('_deselect').toLowerCase(),
        trackBy: 'value',
        options: this.options,
        name: `${this.name}-filter`,
        label: 'text'
      }

      let multiple = {
        multiple: true,
        closeOnSelect: false,
        clearOnSelect: false,
        preserveSearch: true
      }

      return this.multipleSelect ? { ...basic, ...multiple } : basic
    }
  }
}
